import Vue from "vue";
import Router from "vue-router";
import Signin from "./pages/Signin.vue";
import Forgetpassword from "./pages/Forgetpassword";
import Signup from "./pages/Signup.vue";
import Admin from "./pages/Admin.vue";
import Home from "./pages/Home.vue";
import Post from "./pages/Post.vue";
import Notification from "./pages/Notification";
import Vendorsignup from "./pages/Vendorsignup.vue";
import Journeyplanner from "./pages/Journeyplanner.vue";
import Vendorservices from "./pages/Vendorservices.vue";
import Bannerads from "./pages/Bannerads.vue";
import Bannerlist from "./pages/BannerList.vue";
import Updatebanner from "./pages/Updatebanner.vue";
import FeaturedList from "./pages/FeaturedList.vue";
import FeaturedAdd from "./pages/FeaturedAdd.vue";
import FeaturedUpdate from "./pages/FeaturedUpdate.vue";
import Myaccount from "./pages/Myaccount.vue";
import Destinationlist from "./pages/Destinationlist.vue";
import Areaofinterest from "./pages/Areaofinterest.vue";
import Packages from "./pages/Packages.vue";
import Aboutus from "./pages/Aboutus.vue";
import UserPost from "./pages/UserPost.vue";
import UserPostGrid from "./pages/UserPostGrid.vue";
import OfferPost from "./pages/OfferPost.vue";
import UserPostSingle from "./pages/UserPostSingle.vue";

import Contacts from "./pages/Contacts.vue";
import Profile from "./pages/Profile.vue";
import Chatuser from "./pages/Chatuser.vue";
import Journeylist from "./pages/Journeylist.vue";
import Newjourney from "./pages/Newjourney.vue";
import Requirementlist from "./pages/Requirementlist.vue";
import Balancecredits from "./pages/Balancecredits.vue";
import Createoffercategories from "./pages/Createoffercategories.vue";
import CreateofferImages from "./pages/Createofferimages.vue";
import journeyyList from "./pages/journeyyList.vue";
import Offercategories from "./pages/Offercategories.vue";
import OfferPostSingle from "./pages/OfferPostSingle.vue";
import Updateoffercategories from "./pages/Updateoffercategories.vue";
// import FilterList1 from "./pages/FilterList1.vue";
import FilterList2 from "./pages/FilterList1new.vue";
import Verify from "./pages/Verify.vue";
import Wishlist from "./pages/Wishlist.vue";
import OffersList from "./pages/Offerslist.vue";
import FilterList1Gridview from "./pages/FilterList1_gridview.vue";
import Rewards from "./pages/Rewards.vue";
import MerchantProfile from "./pages/MerchantView.vue";
import PostRequirement from "./pages/PostRequirement.vue";
import Updaterquirement from "./pages/Updaterquirement.vue";
import TravelRequirement from "./pages/TravelRequirement.vue";
import Journeycategories from "./pages/Journeycategories.vue";
import Updatejourney from "./pages/Updatejourney.vue";

Vue.use(Router);

const router = new Router({
  routes: [
  
    {
      path: "/dashboard",
      component: Admin,
      name: "Dashboard",
    },

    {
      path: "/vendor-services",
      component: Vendorservices,
      name: "Vendorservices",
    },
    {
      path: "/banner-ads",
      component: Bannerads,
      name: "Bannerads",
    },
    {
      path: "/banner-list",
      component: Bannerlist,
      name: "Bannerlist",
    },
    {
      path: "/update-banner/:id",
      component: Updatebanner,
      name: "Updatebanner",
    },
    {
      path: "/featured-list",
      component: FeaturedList,
      name: "FeaturedList",
    },
    {
      path: "/featured-add",
      component: FeaturedAdd,
      name: "FeaturedAdd",
    },
    {
      path: "/featured-update/:id",
      component: FeaturedUpdate,
      name: "FeaturedUpdate",
    },
    {
      path: "/notification",
      component: Notification,
      name: "notification",
    },
    {
      path: "/wishlist",
      component: Wishlist,
      name: "Wishlist",
    },
    {
      path: "/my-account",
      component: Myaccount,
      name: "Myaccount",
    },
    {
      path: "/",
      component: Home,
      name: "Home",
    },

    {
      path: "/about-us",
      component: Aboutus,
      name: "Aboutus",
    },

    {
      path: "/user-post",
      component: UserPost,
      name: "UserPost",
    },
    {
      path: "/user-post-grid",
      component: UserPostGrid,
      name: "UserPostGrid",
    },
    {
      path: "/offer-post",
      component: FilterList2,
      name: "OfferPost",
      props: true,
    },
    
    {
      path: "/user-post-single/:id",
      component: UserPostSingle,
      name: "UserPostSingle",
    },
    {
      path: "/user-post-single/:id/:slug",
      component: UserPostSingle,
      name: "UserPostSingle",
    },
    {
      path: "/offer-post-single/:id",
      component: OfferPostSingle,
      name: "OfferPostSingle",
    },
    {
      path: "/offer-post-single/:id/:slug",
      component: OfferPostSingle,
      name: "OfferPostSingle",
    },
   
    {
      path: "/contact-us",
      component: Contacts,
      name: "Contacts",
    },

    {
      path: "/packages",
      component: Packages,
      name: "Packages",
    },

    {
      path: "/merchant-signup",
      component: Vendorsignup,
      name: "Vendorsignup",
    },
    {
      path: "/newjourney",
      component: Journeyplanner,
      name: "Journeyplanner",
    },
    {
      path: "/new-journey",
      component: Newjourney,
      name: "Newjourney",
    },
    {
      path: "/requirement-list",
      component: Requirementlist,
      name: "requirementlist",
    },
    {
      path: "/balance-credits",
      component: Balancecredits,
      name: "Balancecredits",
    },
    {
      path: "/my-journey",
      component: Journeylist,
      name: "Journeylist",
    },
    {
      path: "/my-profile",
      component: Profile,
      name: "Profile",
    },
    {
      path: "/chat-user",
      component: Chatuser,
      name: "Chatuser",
    },
    {
      path: "/add-destination-list/:id",
      component: Destinationlist,
      name: "DestinationlistwithId",
    },

    {
      path: "/add-destination-list",
      component: Destinationlist,
      name: "Destinationlist",
    },

    {
      path: "/post/:id",
      component: Post,
      name: "Post",
    },
    {
      path: "/signin",
      component: Signin,
      name: "Signin",
    },
    {
      path: "/forget-password",
      component: Forgetpassword,
      name: "Forgetpassword",
    },
    {
      path: "/signup",
      component: Signup,
      name: "Signup",
    },
    {
      path: "/offers-of-interest",
      component: Areaofinterest,
      name: "Areaofinterest",
    },
    {
      path: "/rewards",
      component: Rewards,
      name: "Rewards",
    },
    {
      path: "/post-requirement",
      component: PostRequirement,
      name: "PostRequirement",
    },
    {
      path: "/Update-rquirement/:id",
      component: Updaterquirement,
      name: "Updaterquirement",
    },
    {
      path: "/travel-requirement",
      component: TravelRequirement,
      name: "TravelRequirement",
    },
    {
      path: "/create-offers",
      component: Createoffercategories,
      name: "Createoffercategories",
    },
    {
      path: "/offer-images/:id",
      component: CreateofferImages,
      name: "Createofferimages",
    },
    {
      path: "/offer-list",
      component: Offercategories,
      name: "Offercategories",
    },
    {
      path: "/journey-list",
      component: journeyyList,
      name: "journeyyList",
    },
    {
      path: "/update-offer/:id",
      component: Updateoffercategories,
      name: "Updateoffercategories",
    },
    {
      path: "/filter-list-1",
      component: OfferPost,
      name: "FilterList1",
      //meta:{ pincode: this.route.params.pincode || '401203' }
      props: { pincode: { type: Number, default: 401203 } },
    },
    {
      path: "/filter-list-2",
      component: FilterList2,
      name: "FilterList2",
      //meta:{ pincode: this.route.params.pincode || '401203' }
      props: true,
    },
    {
      path: "/verify/:id",
      component: Verify,
      name: "Verify",
      //meta:{ pincode: this.route.params.pincode || '401203' }
    },
    {
      path: "/filter-list-1-gridview",
      component: FilterList1Gridview,
      name: "FilterList1Gridview",
      props: {
        search: {
          pincode: "",
          location: "",
          categories: [],
          subcategories: [],
          mindiscount: "",
          maxdiscount: "",
          discount_type: "percent",
          rating: "",
        },
      },
    },
    {
      path: "/offer-list",
      component: OffersList,
      name: "OfferList",
    },
    {
      path: "/merchant/profile/:slug",
      component: MerchantProfile,
      name: "MerchantProfile",
    },
    {
      path: "/journey-categories/:id",
      component: Journeycategories,
      name: "JourneyOfferCategories",
    },
    {
      path: "/update-journey/:id",
      component: Updatejourney,
      name: "Updatejourney",
    },
  ],
  mode: "history",
});

export default router;
